'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="rounded-2xl border p-6">
      <div className="mb-2 font-medium">Something broke.</div>
      <p className="mb-4 text-sm text-muted-foreground">Please try again, or refresh the page.</p>
      <button onClick={reset} className="rounded-md border px-3 py-2 text-sm">
        Try again
      </button>
    </div>
  )
}
